module.exports = __webpack_public_path__ + "img/DualSimSmartphone.ec261a70.jpg";